export default [
  { key: 'GRAIN_FREE', name: 'grainFree', title: 'Grain free' },
  {
    key: 'JOINT_STIFFNESS',
    name: 'jointStiffness',
    title: 'Joint Stiffness',
  },
  { key: 'SENSITIVE_SKIN', name: 'sensitiveSkin', title: 'Sensitive skin' },
  { key: 'ITCHY_PAWS', name: 'itchyPaws', title: 'Itchy paws' },
  {
    key: 'DELICATE_STOMACH',
    name: 'delicateStomach',
    title: 'Delicate stomach',
  },
  { key: 'PICKY_EATER', name: 'pickyEater', title: 'Picky eater' },
  { key: 'BRAIN_WELLNESS', name: 'brainWellness', title: 'Brain wellness' },
  { key: 'GREEDY_EATER', name: 'greedyEater', title: 'Greedy eater' },
  { key: 'GROWING_DOG', name: 'growingDog', title: 'Growing dog' },
  { key: 'ACTIVE_DOG', name: 'activeDog', title: 'Active dog' },
  { key: 'LOOSE_POOP', name: 'loosePoop', title: 'Loose poop' },
  { key: 'NEUTERED', name: 'neutered', title: 'Neutered' },
  { key: 'AGING_DOG', name: 'agingDog', title: 'Aging dog' },
  {
    key: 'TENDENCY_TO_GAIN_WEIGHT',
    name: 'tendencyToGainWeight',
    title: 'Tendency to gain weight',
  },
];
